module.exports = __webpack_public_path__ + "10a3684784c77d3c0471587a319f7b6e.png";


//////////////////
// WEBPACK FOOTER
// ./images/head/gc_head_22.png
// module id = 896
// module chunks = 0